"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ponte-nossa": {
    "2f35467e": [{
      "hkey": "9e9e30a0",
      "slug": "ponte-nossa",
      "name": "Ponte Nossa",
      "primary": true,
      "skipSearch": false
    }],
    "campo-lungo": [{
      "hkey": "9e9e30a0",
      "slug": "ponte-nossa",
      "name": "Ponte Nossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ac90e0fd": [{
      "hkey": "9e9e30a0",
      "slug": "ponte-nossa",
      "name": "Ponte Nossa",
      "primary": true,
      "skipSearch": false
    }],
    "capra": [{
      "hkey": "9e9e30a0",
      "slug": "ponte-nossa",
      "name": "Ponte Nossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0f3377cd": [{
      "hkey": "9e9e30a0",
      "slug": "ponte-nossa",
      "name": "Ponte Nossa",
      "primary": true,
      "skipSearch": false
    }],
    "ponte": [{
      "hkey": "9e9e30a0",
      "slug": "ponte-nossa",
      "name": "Ponte Nossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b2cca3ea": [{
      "hkey": "9e9e30a0",
      "slug": "ponte-nossa",
      "name": "Ponte Nossa",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-riso": [{
      "hkey": "9e9e30a0",
      "slug": "ponte-nossa",
      "name": "Ponte Nossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "521fbe18": [{
      "hkey": "9e9e30a0",
      "slug": "ponte-nossa",
      "name": "Ponte Nossa",
      "primary": true,
      "skipSearch": false
    }],
    "spiazzi": [{
      "hkey": "9e9e30a0",
      "slug": "ponte-nossa",
      "name": "Ponte Nossa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;